import axios from "axios";
import config from "@/../config";
const defaultErrorHandler = (error) => Promise.reject(error.response);

const state = {};

const mutations = {};

const actions = {
  async GET_MOTIVOS_CANCELAMENTO({ commit }, payload) {
    let response = await axios.get(
      config.apiUrl + config.versoes[0] + "/cancelamentos/motivos/"
    );
    return response.data;
  },

  async POST_CANCELAMENTO({ commit }, payload) {
    let response = await axios.post(
      config.apiUrl + config.versoes[0] + "/cancelamentos/",
      payload
    );
    return response.data;
  },

  async POST_ENDORSEMENT(context, payload) {
    const { cd_apolice } = payload;
    const baseUrl = config.apiUrl + config.versoes[0];
    const { data } = await axios.post(
      `${baseUrl}/apolices/${cd_apolice}/endossos/`,
      payload
    );
    return data;
  },

  async GET_AUTO_APPROVAL_ENDORSEMENT(Gcontext, payload) {
    const { id_endosso_gerado } = payload;
    const baseUrl = config.apiUrl + config.versoes[0];
    const { data } = await axios.get(
      `${baseUrl}/endossos/${id_endosso_gerado}/regras/`,
      payload
    );
    return data;
  },

  async GET_ENDORSEMENT_PREMIUM({ commit }, { apoliceId, endossoId }) {
    const baseUrl = config.apiUrl + config.versoes[0];
    const { data } = await axios.get(
      `${baseUrl}/apolices/${apoliceId}/premio-endosso/${endossoId}`
    );
    return data;
  },

  async GET_POLICY_OBJECT({ commit }, { apoliceId }) {
    const baseUrl = config.apiUrl + config.versoes[0];
    const { data } = await axios.get(
      `${baseUrl}/apolices/${apoliceId}/objeto/`
    );
    return data;
  },

  async SEND_ENDORSEMENT_DOCUMENTS({ commit }, { apoliceId, model }) {
    const baseUrl = config.apiUrl + config.versoes[0];
    const { data } = await axios.post(
      `${baseUrl}/apolices/${apoliceId}/enviar_documentos/`,
      model
    );
    return data;
  },
};

export default { state, mutations, actions };



// WEBPACK FOOTER //
// ./src/store/modules/endosso.js